export default "__VITE_ASSET__XnyPgDS5__"